// @flow
import {parseURL} from '@homeaway/search-url-parser';
import type {SearchRequest} from '@homeaway/search-url-parser';
import searchParamActions from '../../actions/searchParams';
import {getUri} from '../../utils/urlUtils';
import type {Store} from '../../reducers/index';

export const defaultIfUndefined = (param?: any, defaultValue: any) => {
    return typeof param === 'undefined' ? defaultValue : param;
};

export const initQParam = (
    store: Store,
    // TODO Add flow type to `payload` when redux-little-router upgraded to ^15.1.0
    action: {type: string, payload: Object}
) => {
    const {description} = action && action.payload;
    /* Update our state to match the new cookie */
    store.dispatch(searchParamActions.initQ(description));
};

export const parseSearchParams = (
    store: Store,
    // TODO Add flow type to `payload` when redux-little-router upgraded to ^15.1.0
    action: {type: string, payload: Object}
) => {
    const {siteName, currency} = store.getState().system;
    const {pathname, search} = action.payload;

    // we have to add 'search' since 'pathname' doesn't include the query string
    let paramsFromGT: SearchRequest = parseURL(getUri({pathname, search}), {
        name: siteName
    });

    if (paramsFromGT.maxPrice || paramsFromGT.minPrice) {
        paramsFromGT = {
            ...paramsFromGT,
            currency
        };
    }
    /* Update our state to match the new cookie */
    store.dispatch(searchParamActions.setSearchParams({params: paramsFromGT}));
};
